import { useMediaQuery } from '@mui/material'
import { authRoles, isOnlyRole } from 'app/auth/authRoles'
import { Layout1SettingsChtc } from 'app/EgretLayout/Layout1/Layout1SettingsChtc'
import Brand from 'app/EgretLayout/SharedCompoents/Brand'
import { ReduxState, ReduxUser } from 'app/redux/ReduxInterfaces'
import sfOauthConfig from 'app/services/sfAuth/sfAuthConfig'
import HelpIconButton from 'app/views/topbar/HelpIconButton'
import SelectLanguageDropdown from 'app/views/topbar/SelectLanguageDropdown'
import { SelectOrganizationDropdown } from 'app/views/topbar/SelectOrganizationDropdown'
import { useSelector } from 'react-redux'
import { HelpButton } from '../views/topbar/HelpButton'
import { LogoutButton } from '../views/topbar/LogoutButton'
import { UserProfileButton } from '../views/topbar/UserProfileButton'
import './Topbar.scss'
import { HELP_CASE_TYPES } from 'app/services/sfAuth/sfData/sfCaseTypes'

function Topbar (): JSX.Element {
  const user = useSelector<ReduxState, ReduxUser>(state => state.user)
  const settings = useSelector<{ layout: { settings: { layout1Settings: Layout1SettingsChtc } } }>
  (state => state.layout.settings) as { layout1Settings: Layout1SettingsChtc }
  const isInternal = sfOauthConfig.isInternal as boolean
  const isSmallScreen = useMediaQuery('(max-width: 1280px)')

  const hideHelpButton =
    isOnlyRole(user.role, authRoles.DMAH) ||
    isOnlyRole(user.role, authRoles.selectionCommittee) ||
    isSmallScreen

  return (
    <div className='topbar'>
      {settings?.layout1Settings?.leftSidebar?.mode === 'close' && <Brand />}
      <div className='topbar-section'>
        <SelectLanguageDropdown />
        {!hideHelpButton && !isInternal && (
          <HelpButton caseType={HELP_CASE_TYPES.CONTACT_US} />
        )}
        {!isSmallScreen
          ? <HelpButton caseType={HELP_CASE_TYPES.HELP} />
          : <div style={{ width: '10px' }} />}
      </div>
      <div className='topbar-section topbar-center'>
        {/* <TourButton />
        <EditingUsersPanel />
      */}
        {!isInternal && <SelectOrganizationDropdown isSmallScreen={isSmallScreen} />}
      </div>
      <div className='topbar-section'>
        <UserProfileButton isSmallScreen={isSmallScreen} />
        {isSmallScreen && <HelpIconButton caseType={HELP_CASE_TYPES.HELP} />}
        <LogoutButton isSmallScreen={isSmallScreen} />
      </div>
    </div>
  )
}

export default Topbar
